module.exports = __webpack_public_path__ + "img/line-engine-sm.e05dd379.svg";